interface Props {
  [key: string]: any
}

function CircleOutlineThinIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 12 12" {...rest} xmlns="http://www.w3.org/2000/svg">
      <circle
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        cx="6"
        cy="6"
        r="5.75"
        stroke="none"
        strokeWidth="0.5"
      />
    </svg>
  )
}

export default CircleOutlineThinIcon
